import * as React from "react";
import { observer } from "mobx-react";
import {
  GridList,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Snackbar,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import { RateLibraryService } from "modules/rateLibrary/RateLibraryService";
import CardGrid from "modules/rateLibrary/components/layouts/CardGrid";
import i18n from "i18n";
import EditLocation from "modules/rateLibrary/components/layouts/EditLocation";
import ShareRateLibrary from "modules/rateLibrary/components/layouts/ShareRateLibrary";
import {
  NoResultsFound,
  NoResultsSearchFound,
} from "modules/development/components/layouts";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
  root: {
    display: "flex",
    flex: 0,
    justifyContent: "flex-start",
    paddingTop: "25px",
    height: "calc(100vh - 128px)",
    backgroundColor: "#F4F4F4",
    overflow: "auto",
  },
  gridList: {
    margin: "0px !important",
    padding: 15,
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
});

@observer
class RateLibraryGridList extends React.Component {
  state = {
    disabledDeleteModalActions: false,
  };

  componentDidMount() {
    RateLibraryStore.loading = true;
  }

  // CHANGE IMAGE EVENTS
  handleChangeImage = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    if (file) {
      var allowedExtensions = /(\.jpg|\.gif|\.png)$/i;
      if (!allowedExtensions.exec(file.name)) {
        e.target.value = null;
        file = null;
        RateLibraryStore.snackOpen = true;
        RateLibraryStore.snackMessage = i18n.library.message.errorImageFormat;
        return;
      }
      if (file.size > 512000) {
        RateLibraryStore.snackOpen = true;
        RateLibraryStore.snackMessage =
          i18n.developments.exceptions.filetobig500k;
      } else
        await RateLibraryService.changeRateLibraryImage(
          RateLibraryStore.updateImageRateLibrary,
          file
        );
    }
    this.handleFocusBack();
  };

  handleFocusBack = () => {
    RateLibraryStore.updateImageRateLibrary = false;
    window.removeEventListener("focus", this.handleFocusBack);
  };

  clickedFileInput = () =>
    window.addEventListener("focus", this.handleFocusBack);

  handleClose = () => (RateLibraryStore.deleteRateLibrary = false);
  handleConfirm = () =>
    this.setState({ disabledDeleteModalActions: true }, async () => {
      await RateLibraryService.DeleteRateLibrary(
        RateLibraryStore.deleteRateLibrary
      );
      RateLibraryStore.deleteRateLibrary = false;
      this.state.disabledDeleteModalActions = false;
    });

  render() {
    const { disabledDeleteModalActions } = this.state;

    return (
      <div className={css(styles.root)}>
        {RateLibraryStore.librariesView &&
          RateLibraryStore.librariesView.length > 0 &&
          (RateLibraryStore.search !== "" ||
            RateLibraryStore.stateSearch !== "BR") && (
            <GridList id="gridFilter" className={css(styles.gridList)}>
              {RateLibraryStore.librariesView.map((lib) => (
                <CardGrid
                  key={lib.id}
                  rateLibrary={lib}
                  selected={
                    RateLibraryStore.rateLibrarySelected
                      ? RateLibraryStore.rateLibrarySelected.id === lib.id
                      : false
                  }
                />
              ))}
            </GridList>
          )}
        {RateLibraryStore.currentTab === 0 &&
          RateLibraryStore.search === "" &&
          (RateLibraryStore.stateSearch === "BR" ||
            RateLibraryStore.stateSearch === "") &&
          RateLibraryStore.myLibraries &&
          RateLibraryStore.myLibraries.length > 0 && (
            <GridList id="gridMyLibraries" className={css(styles.gridList)}>
              {RateLibraryStore.myLibraries.map((lib) => (
                <CardGrid
                  key={lib.id}
                  rateLibrary={lib}
                  selected={
                    RateLibraryStore.rateLibrarySelected
                      ? RateLibraryStore.rateLibrarySelected.id === lib.id
                      : false
                  }
                />
              ))}
            </GridList>
          )}
        {RateLibraryStore.currentTab !== 0 &&
          RateLibraryStore.search === "" &&
          (RateLibraryStore.stateSearch === "BR" ||
            RateLibraryStore.stateSearch === "") &&
          RateLibraryStore.publicLibraries &&
          RateLibraryStore.publicLibraries.length > 0 && (
            <GridList id="gridPublicLibraries" className={css(styles.gridList)}>
              {RateLibraryStore.publicLibraries.map((lib) => (
                <CardGrid
                  key={lib.id}
                  rateLibrary={lib}
                  selected={
                    RateLibraryStore.rateLibrarySelected
                      ? RateLibraryStore.rateLibrarySelected.id === lib.id
                      : false
                  }
                />
              ))}
            </GridList>
          )}
        {!(
          RateLibraryStore.currentTab !== 0 &&
          RateLibraryStore.search === "" &&
          (RateLibraryStore.stateSearch === "BR" ||
            RateLibraryStore.stateSearch === "") &&
          RateLibraryStore.publicLibraries &&
          RateLibraryStore.publicLibraries.length > 0
        ) &&
          !(
            RateLibraryStore.currentTab === 0 &&
            RateLibraryStore.search === "" &&
            (RateLibraryStore.stateSearch === "BR" ||
              RateLibraryStore.stateSearch === "") &&
            RateLibraryStore.myLibraries &&
            RateLibraryStore.myLibraries.length > 0
          ) &&
          !(
            RateLibraryStore.librariesView &&
            RateLibraryStore.librariesView.length > 0
          ) && (
            <NoResultsFound
              target={i18n.noresults.ratelibrary}
              subtarget={i18n.noresults.library}
            />
          )}
        <input
          type="file"
          ref={(node) => (RateLibraryStore.buttonFileUpload = node)}
          onClick={this.clickedFileInput}
          accept=".jpg, .gif, .png, .gif"
          onChange={this.handleChangeImage}
          style={{ display: "none" }}
        />
        <Dialog
          open={RateLibraryStore.deleteRateLibrary ? true : false}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            {i18n.rateLibraries.delete.title}
            <IconButton
              onClick={this.handleClose}
              className={css(styles.closeIcon)}
              style={{ position: "absolute" }}
              disabled={disabledDeleteModalActions}
            >
              <Close fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {i18n.rateLibraries.delete.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              disabled={disabledDeleteModalActions}
              color="secondary"
            >
              {i18n.cancel}
            </Button>
            <Button
              onClick={this.handleConfirm}
              disabled={disabledDeleteModalActions}
              color="primary"
              autoFocus
            >
              {i18n.rateLibraries.delete.confirm}
            </Button>
          </DialogActions>
        </Dialog>
        <EditLocation />
        <ShareRateLibrary />

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={RateLibraryStore.snackOpen}
          onClose={() => {
            RateLibraryStore.snackOpen = false;
          }}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{RateLibraryStore.snackMessage}</span>}
        />
        {RateLibraryStore.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              backgroundColor: "#fff",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              zIndex: 2,
            }}
          >
            <CircularProgress
              size={100}
              style={{ margin: "0 auto", color: "#9FB408" }}
            />
            <Typography
              style={{
                position: "absolute",
                marginLeft: "calc(50% - 95px)",
                marginTop: "170px",
              }}
            >
              {i18n.rateLibraries.loading}
            </Typography>
          </div>
        )}
      </div>
    );
  }
}

export default RateLibraryGridList;



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/RateLibraryGridList.tsx